import React from 'react';

import useReaskLensBlock from '~/hooks/apis/reporting/useReaskLensBlock';

import BlockMenu, { type BlockMenuItem } from './BlockMenu';
import type { BoardContext } from './BlockView';
import type { Block } from './types';

type ReaskBlockMenuProps = {
  block: Block;
  context: BoardContext;
  label: string;
  title: string;
  icon: React.ReactNode;
  items: Array<BlockMenuItem>;
  blockId?: string;
};

export default function ReaskBlockMenu({ block, context, items, ...props }: ReaskBlockMenuProps) {
  const reask = useReaskLensBlock(block, context);
  return (
    <BlockMenu
      {...props}
      items={items.filter((item) => !item.reask || !reask.isPending).map((item) => (item.reask ? { ...item, run: () => reask.mutate() } : item))}
    />
  );
}
